import React from 'react';
import { useRecentlyVisitedSubmissions } from 'clients/internal/homeService';
import { SkeletonLoader } from 'containers/Search/Submissions';
import { ISubmissionSearchResult } from 'typings/submission';
import RecentlyReadSubmission from './RecentlyReadSubmission';
import EmptyState from 'components/Cards/RecentlyReadCard/EmptyState';
import { MainTitle } from 'components/UserEvents/style';
import { Divider } from 'components/UserEvents/style';
import { logEvent } from 'utils/eventTracking';

const RecentlyVisitedSubmissions = () => {
  const title = 'RECENTLY READ';
  const { data: submissions, isLoading } = useRecentlyVisitedSubmissions();

  const renderCard = () => {
    return submissions?.data?.map((submission: ISubmissionSearchResult) => (
      <RecentlyReadSubmission
        key={submission.id}
        submission={submission}
        logEvent={() =>
          logEvent('HOME_RECENTLY_VISITED_CLICKED', {
            type: 'submission',
            id: submission.id
          })
        }
      />
    ));
  };

  if (isLoading) {
    return (
      <>
        <SkeletonLoader />
        <SkeletonLoader />
      </>
    );
  }
  if (!isLoading && submissions?.total === 0) {
    return (
      <>
        <MainTitle>{title}</MainTitle>
        <EmptyState />
        <Divider />
      </>
    );
  }
  return (
    <div>
      <MainTitle>{title}</MainTitle>
      {renderCard()}
      <Divider />
    </div>
  );
};

export default RecentlyVisitedSubmissions;
